<template>
  <v-layout column>
    <div>
      <h1
        class="display-1"
        v-text="$t('activity_reservation.payment_method')"
      />
    </div>

    <v-flex v-if="allPaymentMethodsEnabled.length">
      <v-layout
        class="mt-6 item-payment-method-container"
        wrap
        style="gap: 15px;"
      >
        <v-sheet
          v-for="paymentMethod of allPaymentMethodsEnabled"
          :key="paymentMethod.id"
          class="item-payment-method"
          :class="{'selected-item-payment-method': isSelected(paymentMethod.id) }"
          height="123"
          :elevation="isSelected(paymentMethod.id) ? 0 : 5"
          @click="selectedPaymentMethod = paymentMethod.id"
        >
          <v-layout
            column
            fill-height
          >
            <v-flex class="pa-2" style="height: 60%;">
              <v-layout fill-height justify-center align-end>
                <v-avatar size="34">
                  <v-icon
                    v-if="paymentMethod.typeImage === 'ICON'"
                    color="primary"
                    v-text="paymentMethod.image"
                  />
                  
                  <v-img
                    v-else-if="paymentMethod.typeImage === 'IMAGE'"
                    :src="paymentMethod.image"
                  />
                </v-avatar>
              </v-layout>
            </v-flex>

            <v-flex class="px-2 pb-2"  style="height: 40%;">
              <p class="ma-0 text-center" style="font-size: 12px; line-height: 16px; color: rgba(0, 0, 0, 0.54);"> {{ paymentMethod.name }} </p>
            </v-flex>
          </v-layout>         
        </v-sheet>
      </v-layout>
    </v-flex>

    <div v-else class="py-5">
      <p class="grey--text caption ma-0 text-center" v-text="$t('activity_reservation.warning.no_payment_methods')"/>
    </div>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import activityMixins from '@/mixins/Activity'

export default {
  name: 'ActivityPaymentMethods',

  mixins: [
    activityMixins,
  ],

  computed: {
    ...mapState({
      paymentServiceId: state => state.activityReservations.edited.paymentServiceId,
    }),

    selectedPaymentMethod: {
      get () {
        return this.paymentServiceId ? this.paymentServiceId : null
      },
      set (value) {
        this.$store.commit('activityReservations/setField', {
          field: 'paymentServiceId',
          value,
        })
      },
    },

    allPaymentMethodsEnabled () {
      const paymentMethodsEnabled = this.allPaymentMethods.filter(({ enabled }) => enabled)

      if (paymentMethodsEnabled.length === 1) {
        this.selectedPaymentMethod = paymentMethodsEnabled[0].id
      }
      
      return paymentMethodsEnabled
    },
  },

  methods: {
    isSelected (id) {
      return this.selectedPaymentMethod === id
    },
  },
}
</script>

<style lang="scss">
.item-payment-method-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(123px, 1fr));

  .item-payment-method {
    cursor: pointer;
    border-radius: 10px;

    .v-avatar::before {
      background-color: var(--v-primary-base);
      bottom: 0;
      content: "";
      left: 0;
      opacity: 0.2;
      pointer-events: none;
      position: absolute;
      right: 0;
      top: 0;
    }

    &.selected-item-payment-method {
      cursor: default;

      border-color: var(--v-primary-base) !important;
      border: 2px solid;
    }
  }
}
</style>